import ExecAPI from 'appRoot/api/api';

export function GetGraphiteUserData()
{
	return ExecAPI("GraphiteUserData/GetGraphiteUserData");
}